<div class="box">
    <div class="itax-body">
        <div class="position-relative w-100 h-100">
            <div class="row no-gutters">
                <div class="col-12 position-relative">
                    <div class="d-flex justify-content-center pb-10px">
                        <img [src]="logo" class="image" alt="logo" title="logo">
                    </div>
                    <h1 class="h1 w-100 text-center mb-10px px-20px">เทศกาลลดหย่อนภาษีประจำปี</h1>
                    <p class="p1 font-weight-bold w-100 text-center mb-30px px-20px">
                        {{date}}
                    </p>
                </div>
            </div>
            <div class="row mt-20px no-gutters">
                <div class="col-12 position-relative">
                    <div class="wrap-img">
                        <figure class="bg-img m-0"
                        >
                            <img [src]="bgImg" [style.min-height]="bgImgHeight" alt="background" title="background">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
